<app-cms-top-bar></app-cms-top-bar>
<div id="wrapper">
    <app-cms-side-bar [active]="'satisfaction-management'"></app-cms-side-bar>
    <div id="content-wrapper">

        <div class="container-fluid">
            <p class="title">การจัดการความพึงพอใจ</p>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active text-center" id="chart_satisfaction-tab" data-toggle="tab"
                        href="#chart_satisfaction" role="tab" aria-controls="chart_satisfaction"
                        aria-selected="true">ข้อมูลแบบกราฟ</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-center" id="table-tab" data-toggle="tab" href="#table" role="tab"
                        aria-controls="table" aria-selected="false">ข้อมูลแบบตาราง</a>
                </li>
            </ul>

            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="chart_satisfaction" role="tabpanel"
                    aria-labelledby="chart_satisfaction-tab">

                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-12">
                                <div id="chartdiv_Standard"></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="tab-pane fade" id="table" role="tabpanel" aria-labelledby="table-tab">

                    <!-- Form  -->
                    <div class="table-responsive" style="overflow-x: hidden;">
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-12 text-right">
                                จำนวนทั้งหมด: {{count}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-12" style="padding-top: 5%; padding-left: 10%; padding-right: 10%;">
                                <table class="table table-bordered">
                                    <thead class="head-tb" style="text-align: center;">
                                        <tr>
                                            <th style="width: 75px;">ลำดับที่</th>
                                            <th style="width: 130px;">IP Address</th>
                                            <th style="text-align: left;">ความคิดเห็น</th>
                                        </tr>
                                    </thead>
                                    <tbody class="line-tb">
                                        <tr *ngFor="let list of pageOfItems; let i = index">
                                            <td style="text-align: center;">{{list.number}}</td>
                                            <td *ngIf="list.score == 0"></td>
                                            <td *ngIf="list.score == 1"><i class="fas fa-star icon-star"></i></td>
                                            <td *ngIf="list.score == 2"><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i></td>
                                            <td *ngIf="list.score == 3"><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i></td>
                                            <td *ngIf="list.score == 4"><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i></td>
                                            <td *ngIf="list.score == 5"><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i><i class="fas fa-star icon-star"></i></td>
                                            <td>{{list.ipUser}}</td>
                                            <td>{{list.commect}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- Pagination -->
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-12 text-center">
                                <ul class="pagination justify-content-center">
                                    <jw-pagination [items]="items" (changePage)="onChangePage($event)">
                                    </jw-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>
